export default __webpack_public_path__ + "static/media/nene.d7d8d960.png";